import { create } from 'zustand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/india`;

export const useCompareStore = create((set, get) => ({
  symbols: [],
  inputValue: '',
  companies: [],
  loading: false,
  error: null,
  suggestions: [],
  sugLoading: false,

  setInputValue: (v) => set({ inputValue: v }),

  addSymbol: (sym) => {
    const s = sym.toUpperCase().trim();
    const { symbols } = get();
    if (s && !symbols.includes(s) && symbols.length < 5) {
      set({ symbols: [...symbols, s], inputValue: '' });
    }
  },

  removeSymbol: (sym) => {
    set({ symbols: get().symbols.filter(s => s !== sym) });
  },

  searchSymbols: async (q) => {
    if (!q || q.length < 2) { set({ suggestions: [] }); return; }
    set({ sugLoading: true });
    try {
      const res = await fetch(`${API}/securities?search=${encodeURIComponent(q)}&page_size=8`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      set({ suggestions: (data.items || []).map(i => ({ symbol: i.nse_symbol, name: i.company_name })).filter(i => i.symbol), sugLoading: false });
    } catch {
      set({ sugLoading: false });
    }
  },

  fetchComparison: async () => {
    const { symbols } = get();
    if (symbols.length < 2) { set({ error: 'Add at least 2 symbols to compare.' }); return; }
    set({ loading: true, error: null });
    try {
      const res = await fetch(`${API}/compare?symbols=${symbols.join(',')}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      set({ companies: data.companies || [], loading: false });
    } catch (err) {
      set({ loading: false, error: err.message });
    }
  },
}));
